/**
 * Enum for onboarding step numbers to make the flow more maintainable
 * and avoid hardcoded step numbers throughout the codebase
 */
export enum OnboardingStep {
  // BIRTHDAY = 0, // Disabled - not in use
  ANNUAL_INCOME = 1,
  LIQUID_NET_WORTH = 2,
  TAX_FILING_LOCATION = 3,
  FILING_STATUS_OR_REQUEST_ACCESS = 4, // FilingStatus for US, RequestAccess for non-US
  RISK_PREFERENCE = 5, // US only
  ACCREDITATION = 6, // US only
  LEAD_CAPTURE = 7, // US only
}

/**
 * Helper function to get step name for tracking purposes
 */
export const getStepName = (stepNum: number, country?: string): string => {
  const stepNames: Record<number, string> = {
    [OnboardingStep.ANNUAL_INCOME]: 'annual_income',
    [OnboardingStep.LIQUID_NET_WORTH]: 'liquid_net_worth',
    [OnboardingStep.TAX_FILING_LOCATION]: 'tax_filing_location',
    [OnboardingStep.FILING_STATUS_OR_REQUEST_ACCESS]:
      country !== 'US' ? 'request_access' : 'filing_status',
    [OnboardingStep.RISK_PREFERENCE]: 'risk_preference',
    [OnboardingStep.ACCREDITATION]: 'accreditation',
    [OnboardingStep.LEAD_CAPTURE]: 'lead_capture',
  };
  return stepNames[stepNum] || `step_${stepNum}`;
};
